import { DropEvent, DropzoneOptions, FileRejection, useDropzone } from 'react-dropzone';
import { dragAndDropStyles, uploadButtonStyles } from './Uploader.styles';

interface UploaderProps {
  onDrop: <T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) => void;
  mediaType: CF.UI.UISupportedUploadTypes;
  dropzoneOptions?: DropzoneOptions;
  height?: string;
  uploadIcon?: string;
  uploadedImageManager?: JSX.Element;
}

export const Uploader = (props: UploaderProps): JSX.Element => {
  const { onDrop, mediaType, dropzoneOptions, height, uploadedImageManager, uploadIcon = '/icons/uploader-small.svg' } = props;

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    noClick: true,
    accept: `${mediaType.split(',').join('/*,')}/*`,
    multiple: false,
    ...dropzoneOptions,
  });

  const dragActiveState = (
    <span className="bold" data-testid="drag-active-state">
      Drop files here...
    </span>
  );
  const dragInactiveState = (
    <p data-testid="drag-inactive-state">
      <span className="bold">Click to upload</span> or drag &amp; drop
    </p>
  );

  return (
    <div
      {...getRootProps()}
      className={dragAndDropStyles}
      data-testid="uploader"
      style={{ height, border: isDragActive ? '2px solid #195AFF' : '1px dashed #6695f3' }}
    >
      <input {...getInputProps()} data-testid="uploader-input" />
      <button onClick={open} type="button" data-testid="uploader-button" className={uploadButtonStyles}>
        <img alt="upload icon" className="uploader-icon" data-testid="uploader-icon" src={uploadIcon} width={40} height={50} />
        <span className="directions">{isDragActive ? dragActiveState : dragInactiveState}</span>
      </button>
      {uploadedImageManager}
    </div>
  );
};
